module.exports = __webpack_public_path__ + "img/凋谢.e859f234.png";